// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 776 ? "a4c14725" : chunkId) + "." + {"10":"069a8a50d162f41d","776":"58ff2d2f770f7a02"}[chunkId] + ".js";
};